const CardInfo = ({
  icon,
  title,
  value,
  color,
  bgColor,
}) => {
  return (
    <div className="flex min-h-[7rem] items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-[0_10px_28px_rgba(15,23,42,0.10)">
      
      <div
        className={`
          flex h-14 w-14 shrink-0
          items-center justify-center
          rounded-full
          ${bgColor}
        `}
      >
        <div
          className={`
            flex h-7 w-7
            items-center justify-center
            ${color}
          `}
        >
          {icon}
        </div>
      </div>

      <div className="flex flex-col items-center text-center">
        <span className="text-sm font-medium text-gray-600">
          {title}
        </span>

        <span className="mt-1 text-[2rem] font-bold leading-none text-border">
          {value}
        </span>
      </div>
    </div>
  );
};
export default CardInfo;